import type { Step } from "react-joyride";

export const payslipViewTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ໃບເງິນເດືອນ. ທ່ານສາມາດພິມ ຫຼື ກັບໄປແກ້ໄຂລາຍການເງິນເດືອນ.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="payslip-view-actions"]',
    content: "ກັບໄປແກ້ໄຂ ຫຼື ພິມໃບເງິນເດືອນ. ກົດ 'ທົດລອງທົດສອບ' ເພື່ອເລີ່ມທົດສອບການນຳທາງ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="payslip-view-content"]',
    content: "ເນື້ອໃນໃບເງິນເດືອນ: ຂໍ້ມູນພະນັກງານ, ເງິນເດືອນ ແລະ ລາຍການຫັກ.",
    placement: "top",
  },
];
